module.exports = __webpack_public_path__ + "img/angle.262c091d.svg";